import { useState } from "react";

type CtaFormIslandProps = {
  title?: string;
  submitText?: string;
};

export function CtaFormIsland(props: CtaFormIslandProps) {
  const [submitted, setSubmitted] = useState(false);

  return (
    <div className="rounded-[22px] border border-brand-100 bg-[linear-gradient(180deg,rgba(255,255,255,0.98),rgba(238,242,255,0.92))] p-4 shadow-panel">
      <div className="mb-3 text-[12px] font-semibold uppercase tracking-[0.14em] text-brand-700">{props.title || "预约演示"}</div>
      <form
        className="grid gap-3"
        onSubmit={(event) => {
          event.preventDefault();
          setSubmitted(true);
        }}
      >
        <div className="grid gap-2 md:grid-cols-2">
          <input className="min-h-11 rounded-2xl border border-slate-200 bg-white px-4 text-[14px] outline-none" name="name" placeholder="姓名" />
          <input className="min-h-11 rounded-2xl border border-slate-200 bg-white px-4 text-[14px] outline-none" name="contact" placeholder="联系方式" />
        </div>
        <textarea className="min-h-24 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-[14px] outline-none" name="demand" placeholder="需求描述" />
        <button className="inline-flex min-h-11 items-center justify-center rounded-full bg-brand-600 px-6 text-[14px] font-medium text-white shadow-[0_12px_24px_rgba(79,70,229,0.22)] transition-transform hover:-translate-y-0.5" type="submit">
          {props.submitText || "提交"}
        </button>
        {submitted ? <div className="text-[13px] text-emerald-700">已提交占位表单，后续可接入真实试用/咨询链路。</div> : null}
      </form>
    </div>
  );
}
